import React, { FC, useEffect } from 'react'

import Divider from '@vfuk/core-divider'
import { useBreakpoints } from '@vfuk/core-match-media'

import * as Styled from './styles/Footer.style'

import { FooterProps } from './Footer.types'

import Logo from './components/Logo'
import Social from './components/Social'
import MobileLinkList from './components/MobileLinkList'
import DesktopLinkList from './components/DesktopLinkList'
import PartnerInfo from './components/PartnerInfo'
import LegalLinks from './components/LegalLinks'
import CompanyInfo from './components/CompanyInfo'
import PartnerLinks from './components/PartnerLinks'

const Footer: FC<FooterProps> = ({
  social,
  partnerLogo,
  legalLinks,
  companyInfo,
  additionalInfo,
  copyrightText,
  partnerLinks,
  linkGroups,
  onInteractionClick,
  onLoad,
}) => {
  const { mdAndBelow } = useBreakpoints()

  useEffect(() => {
    if (onLoad) {
      onLoad()
    }
  }, [])

  return (
    <Styled.Footer>
      <Styled.FooterContainer>
        <Styled.IconsWrapper>
          <Logo />
          <If condition={social}>
            <Social social={social!} onInteractionClick={onInteractionClick} />
          </If>
        </Styled.IconsWrapper>
        <Styled.DividerWrapper>
          <Divider appearance='secondary' inverse />
        </Styled.DividerWrapper>
        <If condition={linkGroups}>
          <Choose>
            <When condition={mdAndBelow}>
              <MobileLinkList linkGroups={linkGroups!} onInteractionClick={onInteractionClick} />
            </When>
            <Otherwise>
              <DesktopLinkList linkGroups={linkGroups!} onInteractionClick={onInteractionClick} />
            </Otherwise>
          </Choose>
        </If>
        <If condition={partnerLogo}>
          <PartnerInfo partnerLogo={partnerLogo} />
        </If>
        <LegalLinks legalLinks={legalLinks} onInteractionClick={onInteractionClick} />
        <CompanyInfo companyInfo={companyInfo} additionalInfo={additionalInfo} copyrightText={copyrightText} />
        <If condition={partnerLinks}>
          <PartnerLinks partnerLinks={partnerLinks} onInteractionClick={onInteractionClick} />
        </If>
      </Styled.FooterContainer>
    </Styled.Footer>
  )
}

export default Footer
